import { useDebounceCallback } from '@react-hook/debounce';
import { useEffect, useState } from 'react';
import orderBy from 'lodash/orderBy';

const ORDER_BY = {
  NAME: 'name'
};

const usePmEntitiesFilters = ({
  entities = [],
  selectedEntities,
  entityName
}) => {
  const [filteredEntities, setFilteredEntities] = useState(entities);
  const [isSelectedOnly, setIsSelectedOnly] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isFilterLoading, setIsFilterLoading] = useState(false);

  const toggleIsSelectedOnly = () => setIsSelectedOnly(prev => !prev);

  const filterEntities = () => {
    let filteredData = entities;
    if (searchTerm.length > 0) {
      filteredData = filteredData.filter(
        ({ name = '', provider_key = '' }) =>
          name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          provider_key.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (isSelectedOnly) {
      filteredData = filteredData.filter(entity =>
        selectedEntities.isEntitySelected(entity.provider_id)
      );
    }

    const orderedFilteredData = orderBy(filteredData, ORDER_BY.NAME);
    setFilteredEntities(orderedFilteredData);

    if (isFilterLoading) setIsFilterLoading(false);
  };

  const debouncedFilterEntities = useDebounceCallback(filterEntities, 800);

  const initFilters = () => {
    setIsSelectedOnly(false);
    setSearchTerm('');
  };

  useEffect(() => {
    setIsFilterLoading(true);
    debouncedFilterEntities();
  }, [searchTerm, isSelectedOnly]);

  useEffect(() => {
    filterEntities();
  }, [entities, selectedEntities.values.length]);

  useEffect(() => {
    initFilters();
  }, [entityName]);

  return {
    searchTerm,
    setSearchTerm,
    toggleIsSelectedOnly,
    isSelectedOnly,
    filteredEntities,
    isFilterLoading
  };
};

export default usePmEntitiesFilters;
